import React from 'react';
import configuration from '../../assets/window_configuration.png';
import frames from '../../assets/window_frames.png';

function WindowCharts() {
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h6>Configuration Chart</h6>
        <img
          src={configuration}
          alt="Window Configuration Chart"
          style={{ maxWidth: '100%', marginBottom: 8 }}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <h6>Frame Type</h6>
        <img
          src={frames}
          alt="Window Frame Types"
          style={{ maxWidth: '100%', marginBottom: 8 }}
        />
      </div>
    </div>
  );
}

export default WindowCharts;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/charts/WindowCharts.jsx